import JustiTheme from '../Theme/JustiTheme'
import styles from '../styles/common.module.css'
import { CircularProgress } from '@material-ui/core'

/**
 * Custon `Loading` component declaration.
 * @param {String} text
 * @return Loading
 */
export default function Loading({ text }: { text: string }): JSX.Element {
  return (
    <div className={styles.container}>
      <h3>{text || 'Cargando'}</h3>
      <CircularProgress style={{color: JustiTheme.palette.secondary.dark}}/>
    </div>
  )
}